import Modal from 'bootstrap/js/dist/modal';
import $ from 'jquery';

const templateHtml = `
  <div class="modal fade" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div v-if="title" class="modal-header border-bottom-0 pb-0 mt-1">
          <h5 class="modal-title">Which antenna should I pick?</h5>
          <button type="button" class="btn-close me-1" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-start pb-0">
          <p>Pick which frequencies you want to operate on to find out which antenna is right for you.</p>
          <div id="frequencies" class="d-flex justify-content-star gap-2 flex-wrap">
            <button class="btn btn-outline-secondary flex-shrink-0 rounded-pill w-100 d-inline-flex justify-content-between align-items-center" id="2m">
              <span class="icon-unchecked"><i class="fal fa-lg fa-circle me-3"></i></span>
              <span class="icon-checked d-none"><i class="fa fa-lg fa-circle-check me-3"></i></span>
              <div class="d-inline-flex justify-content-between flex-grow-1">
                <span>2 meter / VHF</span>
                <span>(144–148MHz)</span>
              </div>
            </button>
            <button class="btn btn-outline-secondary flex-shrink-0 rounded-pill w-100 d-inline-flex justify-content-between align-items-center" id="70cm">
              <span class="icon-unchecked"><i class="fal fa-lg fa-circle me-3"></i></span>
              <span class="icon-checked d-none"><i class="fa fa-lg fa-circle-check me-3"></i></span>
              <div class="d-inline-flex justify-content-between flex-grow-1">
                <span>70cm / UHF</span>
                <span>(420–450MHz)</span>
              </div>
            </button>
            <button class="btn btn-outline-secondary flex-shrink-0 rounded-pill w-100 d-inline-flex justify-content-between align-items-center" id="125m">
              <span class="icon-unchecked"><i class="fal fa-lg fa-circle me-3"></i></span>
              <span class="icon-checked d-none"><i class="fa fa-lg fa-circle-check me-3"></i></span>
              <div class="d-inline-flex justify-content-between flex-grow-1">
                <span>1.25 meter</span>
                <span>(222–225MHz)</span>
              </div>
            </button>
            <button class="btn btn-outline-secondary flex-shrink-0 rounded-pill w-100 d-inline-flex justify-content-between align-items-center" id="murs">
              <span class="icon-unchecked"><i class="fal fa-lg fa-circle me-3"></i></span>
              <span class="icon-checked d-none"><i class="fa fa-lg fa-circle-check me-3"></i></span>
              <div class="d-inline-flex justify-content-between flex-grow-1">
                <span>MURS</span>
                <span>(151–154MHz)</span>
              </div>
            </button>
            <button class="btn btn-outline-secondary flex-shrink-0 rounded-pill w-100 d-inline-flex justify-content-between align-items-center" id="gmrs">
              <span class="icon-unchecked"><i class="fal fa-lg fa-circle me-3"></i></span>
              <span class="icon-checked d-none"><i class="fa fa-lg fa-circle-check me-3"></i></span>
              <div class="d-inline-flex justify-content-between flex-grow-1">
                <span>GMRS</span>
                <span>(462–467MHz)</span>
              </div>
            </button>
          </div>
          <div id="antennas" class="d-none" class="mt-3">
            <h5 class="mt-4 mb-3">Based on your selections, you need:</h5>
            <div class="d-flex gap-2 align-items-center">
              <button class="btn btn-outline-grey d-none" id="option-band-2m70cm-dual-band">2m/70cm Dual-Band</button>
              <button class="btn btn-outline-grey d-none" id="option-band-440-monoband">440 Monoband</button>
              <span id="and" class="d-none">and</span>
              <button class="btn btn-outline-grey d-none" id="option-band-220-monoband">220 Monoband</button>
            </div>
          </div>
        </div>
        <div class="modal-footer border-top-0"></div>
      </div>
    </div>
  </div>
`;

export function display(): Promise<string | undefined> {
  const template = document.createElement('template');
  template.innerHTML = templateHtml.trim();
  const modalElement = template.content.firstChild as HTMLDivElement;
  const modal = new Modal(modalElement);
  const promise = new Promise<string | undefined>((resolve) => {
    setupListeners(resolve, modal, modalElement);
  });
  modal.show();
  return promise;
}

function setupListeners(resolver: Function, modal: Modal, modalElement: HTMLDivElement) {
  modalElement.addEventListener('hidden.bs.modal', () => modalElement?.remove());
  modalElement.querySelector('[data-bs-dismiss]')?.addEventListener('click', () => modal?.hide());
  modalElement.querySelectorAll('#frequencies button').forEach((button) => {
    button.addEventListener('click', (el) => {
      frequencyToggled(el);
      calculateAntennas(modalElement);
    });
  });
  modalElement.querySelectorAll('#antennas button').forEach((button) => {
    button.addEventListener('click', () => {
      resolver(button.id);
      modal.hide();
    });
  });
}

function frequencyToggled(e: Event) {
  const buttonEl = e.currentTarget as HTMLButtonElement;
  const checked = isChecked(buttonEl);
  setChecked(buttonEl, !checked);
}

function calculateAntennas(modalElement: HTMLDivElement) {
  const selectedFrequencies = Array.from(modalElement.querySelectorAll('#frequencies button'))
    .filter(el => isChecked(el as HTMLButtonElement))
    .map(el => el.id);
  const needs2m = selectedFrequencies.includes('2m') || selectedFrequencies.includes('murs');
  const needs70cm = selectedFrequencies.includes('70cm') || selectedFrequencies.includes('gmrs');
  const needs125m = selectedFrequencies.includes('125m');
  modalElement.querySelectorAll('#antennas button').forEach((el) => el.classList.add('d-none'));
  if (needs2m) {
    modalElement.querySelector('#option-band-2m70cm-dual-band')!.classList.remove('d-none');
  } else if (needs70cm && !needs2m) {
    modalElement.querySelector('#option-band-440-monoband')!.classList.remove('d-none');
  }
  if (needs125m) {
    modalElement.querySelector('#option-band-220-monoband')!.classList.remove('d-none');
  }
  if (!needs2m && !needs70cm && !needs125m) {
    modalElement.querySelector('#antennas')!.classList.remove('d-none');
  } else {
    modalElement.querySelector('#antennas')!.classList.remove('d-none');
  }
  if (needs125m && (needs2m || needs70cm)) {
    modalElement.querySelector('#and')!.classList.remove('d-none');
  } else {
    modalElement.querySelector('#and')!.classList.add('d-none');
  }
}

function isChecked(el: HTMLButtonElement) {
  return el.querySelector('.icon-checked')?.classList.contains('d-none') === false;
}

function setChecked(el: HTMLButtonElement, checked: boolean) {
  const uncheckedEl = el.querySelector('.icon-unchecked')!;
  const checkedEl = el.querySelector('.icon-checked')!;
  if (checked) {
    uncheckedEl.classList.add('d-none');
    checkedEl.classList.remove('d-none');
  } else {
    uncheckedEl.classList.remove('d-none');
    checkedEl.classList.add('d-none');
  }
}